import React from 'react';
import IconBase from 'react-icon-base';

const viewBoxWidth = 335.275;
const viewBoxHeight = 70;

const LogoText = (props) => (
  <IconBase
    viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
    width="100%"
    height="auto"
    {...props}
  >
    <g>
      <path
        fill="currentColor"
        d="M0.979,52.841l0.428-2.103h5.097l8.626-46.587H9.354L9.782,2.19h26.163c8.578,0,15.125,1.824,19.641,5.471
c4.514,3.648,6.771,8.93,6.771,15.845c0,8.769-2.953,15.851-8.857,21.244c-5.905,5.395-13.682,8.091-23.329,8.091H0.979z
 M26.713,50.738h1.319c3.018,0,5.204-0.921,6.559-2.763c1.354-1.841,2.603-5.84,3.743-11.994l2.352-12.618
c0.476-2.685,0.861-5.198,1.159-7.538c0.296-2.341,0.445-3.998,0.445-4.973c0-2.305-0.487-3.998-1.462-5.08
c-0.975-1.08-2.507-1.621-4.598-1.621H35.34L26.713,50.738z"
      />
      <path
        fill="currentColor"
        d="M110.851,18.337c-0.57,2.281-1.188,5.264-1.854,8.947c-0.214,1.188-0.368,2.044-0.464,2.566l-4.312,23.062
c-1.046,5.703-3.439,9.82-7.183,12.35c-3.742,2.531-9.333,3.797-16.771,3.797c-5.347,0-9.238-0.57-11.674-1.711
s-3.653-2.959-3.653-5.453c0-1.973,0.636-3.5,1.907-4.58c1.271-1.082,3.07-1.623,5.4-1.623c2.257,0,4.016,0.482,5.275,1.443
c1.259,0.963,1.889,2.3,1.889,4.011c0,1.116-0.303,2.103-0.909,2.958c-0.605,0.855-0.909,1.355-0.909,1.498
c0,0.428,0.232,0.777,0.695,1.051c0.464,0.273,1.075,0.41,1.836,0.41c2.305,0,4.063-0.784,5.275-2.353s2.21-4.456,2.994-8.661
l3.065-16.575c-1.331,4.183-3.25,7.456-5.757,9.819c-2.508,2.365-5.316,3.547-8.43,3.547c-2.805,0-5.074-0.819-6.809-2.459
s-2.602-3.766-2.602-6.381c0-3.326,0.635-7.229,1.907-11.709c1.271-4.479,1.907-7.075,1.907-7.788c0-0.403-0.102-0.718-0.304-0.944
c-0.202-0.226-0.493-0.339-0.873-0.339c-0.88,0-1.741,0.636-2.584,1.907c-0.845,1.271-1.765,3.332-2.763,6.184l-1.604-0.213
c1.377-4.539,3.23-7.973,5.561-10.302c2.328-2.329,5.049-3.493,8.162-3.493c2.804,0,5.037,0.867,6.701,2.602
c1.663,1.735,2.495,4.076,2.495,7.022c0,2.543-0.606,5.899-1.817,10.069c-1.213,4.17-1.818,6.779-1.818,7.824
c0,0.666,0.131,1.193,0.393,1.586c0.261,0.393,0.617,0.588,1.068,0.588c1.854,0,3.624-2.381,5.312-7.146
c1.687-4.764,3.303-11.946,4.848-21.547c2.542,0.143,4.521,0.244,5.935,0.303c1.414,0.061,2.596,0.09,3.547,0.09
c1.069,0,2.168-0.029,3.297-0.09C108.361,18.546,109.567,18.456,110.851,18.337z"
      />
      <path
        fill="currentColor"
        d="M115.07,53.162c1.52-6.677,2.762-12.755,3.725-18.231c0.962-5.478,1.443-8.87,1.443-10.178
c0-0.451-0.107-0.819-0.32-1.104c-0.215-0.285-0.477-0.428-0.785-0.428c-0.713,0-1.491,0.726-2.334,2.175
c-0.844,1.449-1.646,3.492-2.406,6.131l-1.676-0.285c1.189-4.562,2.994-8.014,5.418-10.355c2.424-2.34,5.395-3.511,8.912-3.511
c2.685,0,4.633,0.796,5.846,2.388c1.211,1.593,1.817,4.195,1.817,7.807c0,0.523-0.024,1.094-0.071,1.711
c-0.048,0.618-0.096,1.236-0.143,1.854c1.354-4.349,3.268-7.729,5.738-10.141c2.472-2.412,5.252-3.618,8.342-3.618
c2.852,0,5.145,0.826,6.879,2.478c1.734,1.652,2.602,3.844,2.602,6.576c0,3.47-0.647,7.533-1.942,12.19
c-1.296,4.657-1.942,7.354-1.942,8.091c0,0.404,0.125,0.737,0.374,0.998c0.25,0.262,0.564,0.393,0.944,0.393
c0.785,0,1.604-0.695,2.46-2.086c0.855-1.389,1.771-3.521,2.745-6.397l1.604,0.214c-1.331,4.705-3.167,8.281-5.507,10.729
c-2.341,2.447-5.056,3.672-8.146,3.672c-2.779,0-5.008-0.903-6.683-2.709c-1.676-1.806-2.513-4.242-2.513-7.307
c0-2.639,0.594-6.131,1.781-10.48c1.188-4.348,1.783-7.08,1.783-8.197c0-0.666-0.138-1.218-0.41-1.658
c-0.273-0.439-0.624-0.659-1.052-0.659c-1.83,0-3.577,2.478-5.239,7.433c-1.664,4.953-3.279,12.469-4.848,22.545
c-1.807-0.119-3.494-0.209-5.062-0.268c-1.568-0.061-3.064-0.09-4.49-0.09c-1.07,0-2.17,0.029-3.298,0.09
C117.487,52.989,116.305,53.067,115.07,53.162z"
      />
      <path
        fill="currentColor"
        d="M163.922,38.085c0-5.799,2.328-10.699,6.986-14.703c4.656-4.004,10.359-6.007,17.109-6.007
c5.773,0,10.432,1.515,13.973,4.544c3.541,3.031,5.311,6.981,5.311,11.853c0,5.608-2.365,10.421-7.094,14.437
s-10.502,6.023-17.322,6.023c-5.656,0-10.23-1.497-13.723-4.491C165.668,46.746,163.922,42.86,163.922,38.085z M188.516,19.192
c-1.068,0-1.93,0.506-2.584,1.516s-1.324,3.012-2.014,6.006c-1.117,4.943-2.025,9.631-2.727,14.062s-1.051,7.217-1.051,8.357
c0,1.07,0.213,1.86,0.641,2.371c0.428,0.512,1.082,0.766,1.961,0.766c1.068,0,1.93-0.504,2.584-1.514
c0.652-1.01,1.324-3.013,2.014-6.007c1.117-4.942,2.02-9.601,2.709-13.973s1.033-7.188,1.033-8.448
c0-1.092-0.207-1.889-0.623-2.388S189.395,19.192,188.516,19.192z"
      />
      <path
        fill="currentColor"
        d="M225.1,67.135h5.918l-0.357,1.925h-27.09l0.357-1.925h5.168l7.236-40.991
c0.07-0.451,0.111-0.766,0.125-0.945c0.012-0.178,0.018-0.326,0.018-0.445c0-0.521-0.096-0.908-0.285-1.158
c-0.191-0.25-0.488-0.374-0.891-0.374c-0.762,0-1.557,0.72-2.389,2.157s-1.641,3.486-2.424,6.148l-1.604-0.285
c1.211-4.586,3.023-8.044,5.436-10.373c2.41-2.328,5.375-3.493,8.893-3.493c2.447,0,4.26,0.694,5.436,2.085
s1.766,3.535,1.766,6.434c0,0.5-0.008,0.887-0.02,1.158c-0.012,0.274-0.029,0.518-0.053,0.731c0.879-3.303,2.418-5.864,4.615-7.681
c2.199-1.818,4.879-2.728,8.039-2.728c3.943,0,7.182,1.421,9.713,4.259c2.531,2.841,3.797,6.529,3.797,11.068
c0,5.988-1.783,11.086-5.348,15.291c-3.564,4.207-7.865,6.31-12.902,6.31c-2.734,0-4.908-0.517-6.523-1.55
c-1.617-1.035-2.732-2.608-3.352-4.724L225.1,67.135z M232.266,48.172c0.926,0,1.729-0.403,2.404-1.212
c0.678-0.808,1.254-2.079,1.73-3.814c0.855-2.97,1.531-5.988,2.031-9.053c0.498-3.066,0.748-5.454,0.748-7.165
c0-1.283-0.244-2.263-0.73-2.94c-0.488-0.678-1.193-1.016-2.121-1.016c-1.045,0-1.943,0.493-2.691,1.479
c-0.748,0.986-1.408,2.561-1.979,4.723c-0.76,2.924-1.371,5.805-1.836,8.645c-0.463,2.84-0.693,4.949-0.693,6.326
c0,1.355,0.254,2.365,0.766,3.03C230.404,47.839,231.195,48.172,232.266,48.172z"
      />
      <path
        fill="currentColor"
        d="M258.049,31.169c1.355-4.348,3.268-7.723,5.738-10.123c2.473-2.399,5.252-3.6,8.342-3.6
c2.875,0,5.162,0.814,6.861,2.441c1.699,1.629,2.549,3.809,2.549,6.541c0,3.47-0.631,7.533-1.889,12.19
c-1.26,4.657-1.891,7.354-1.891,8.091c0,0.404,0.125,0.737,0.375,0.998c0.25,0.262,0.564,0.393,0.945,0.393
c0.783,0,1.598-0.695,2.441-2.086c0.842-1.389,1.752-3.521,2.727-6.397l1.604,0.214c-1.33,4.705-3.16,8.281-5.488,10.729
c-2.33,2.447-5.051,3.672-8.164,3.672c-2.779,0-5.02-0.908-6.719-2.727s-2.549-4.248-2.549-7.289c0-2.639,0.611-6.119,1.836-10.444
s1.836-7.046,1.836-8.163c0-0.713-0.119-1.252-0.355-1.621c-0.238-0.368-0.584-0.553-1.035-0.553c-0.998,0-1.967,0.695-2.904,2.086
c-0.939,1.389-1.895,3.559-2.869,6.504L258.049,31.169z M265.143,7.929c0-2.186,0.777-3.861,2.334-5.025s3.797-1.746,6.719-1.746
c2.9,0,5.121,0.582,6.666,1.746s2.316,2.84,2.316,5.025c0,2.211-0.771,3.898-2.316,5.062s-3.766,1.746-6.666,1.746
c-2.922,0-5.162-0.582-6.719-1.746S265.143,10.14,265.143,7.929z"
      />
      <path
        fill="currentColor"
        d="M332.959,18.409c-1.545,6.771-2.811,12.855-3.797,18.25s-1.479,8.649-1.479,9.766
c0,0.595,0.111,1.07,0.338,1.426c0.225,0.357,0.504,0.535,0.838,0.535c0.736,0,1.52-0.725,2.352-2.174s1.629-3.494,2.389-6.131
l1.676,0.213c-1.189,4.587-2.994,8.057-5.418,10.408c-2.424,2.354-5.383,3.529-8.875,3.529c-2.473,0-4.309-0.707-5.508-2.121
c-1.201-1.413-1.801-3.582-1.801-6.505c0-0.476,0.006-0.837,0.02-1.087c0.01-0.25,0.029-0.481,0.053-0.695
c-0.855,3.303-2.389,5.863-4.598,7.682c-2.211,1.818-4.885,2.727-8.021,2.727c-3.969,0-7.211-1.42-9.73-4.26
c-2.52-2.839-3.777-6.528-3.777-11.067c0-6.012,1.781-11.114,5.346-15.31c3.564-4.193,7.889-6.291,12.975-6.291
c3.422,0,6.006,0.779,7.754,2.334c1.746,1.558,2.738,3.975,2.975,7.254l1.391-8.482c1.664,0.119,3.191,0.208,4.58,0.268
c1.391,0.059,2.715,0.088,3.975,0.088c1.094,0,2.156-0.029,3.191-0.088C330.838,18.617,331.889,18.528,332.959,18.409z
 M311.928,22.401c-0.951,0-1.77,0.428-2.459,1.283s-1.283,2.174-1.783,3.956c-0.832,3.089-1.502,6.226-2.014,9.41
s-0.766,5.68-0.766,7.485c0,1.307,0.25,2.312,0.748,3.012c0.5,0.701,1.199,1.052,2.104,1.052c1.068,0,1.973-0.499,2.709-1.497
s1.414-2.661,2.031-4.99c0.76-2.898,1.367-5.811,1.818-8.732c0.451-2.924,0.678-5.192,0.678-6.809c0-1.426-0.25-2.477-0.75-3.154
C313.746,22.739,312.973,22.401,311.928,22.401z"
      />
    </g>
  </IconBase>
);

export default LogoText;



// WEBPACK FOOTER //
// ./src/app/components/logo/text.js